enum FrameStatus {
    WINDOWED = 'WINDOWED',
    FULLSCREENED = 'FULLSCREENED',
    AFFIXED = 'AFFIXED'
}

export default FrameStatus;